module.exports = {
    'ADD_DIRECTOR': 'add_director',
    'REMOVE_DIRECTOR': 'remove_director',
    'CHANGE_FINANCIAL_YEAR_END': 'change_financial_year_end',
    'ISSUE_SHARES': 'issue_shares',
    'TRANSFER_SHARES': 'transfer_shares',
    'OTHERS': 'others'
};